// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__XzFmW","left":"InfoRow_left__Dgffr"};